import { Dispatch, SetStateAction, VFC } from 'react'
import {
  ContributionSearchConditionsData,
  ContributionsQueryParam,
} from 'src/models/Contribution'
import { defaultShadow } from 'src/styles/colors'
import styled from 'styled-components'
import { _profilegreen } from '../../styles/colors'
import { PopUpMenu } from './PopUpMenu'

export const SearchFilter: VFC<{
  searchContributionSearchConditionsData?: ContributionSearchConditionsData[]
  hasKeywords: boolean
  hasPaid: boolean
  onChangeForAll: () => void
  onChangeFoKeyword: () => void
  onClickSearch: (q?: ContributionsQueryParam) => void
  setSelectedFreeWords: Dispatch<SetStateAction<string[]>>
  setSelectedTypeOfPurchases: Dispatch<SetStateAction<string[]>>
  setSelectedBudgets: Dispatch<SetStateAction<string[]>>
  setSelectedIntroductionTimings: Dispatch<SetStateAction<string[]>>
  setSelectedSpecialties: Dispatch<SetStateAction<number[]>>
  selectedSearchCondition: ContributionSearchConditionsData | undefined
  setSelectedSearchCondition: Dispatch<
    SetStateAction<ContributionSearchConditionsData | undefined>
  >
  setSearchCondition: Dispatch<
    SetStateAction<ContributionSearchConditionsData | undefined>
  >
  setIsOpenFilterSettingModal: Dispatch<SetStateAction<boolean>>
  setIsOpenFilterDeleteModal: Dispatch<SetStateAction<boolean>>
}> = ({
  hasKeywords,
  hasPaid,
  searchContributionSearchConditionsData,
  onChangeForAll,
  onChangeFoKeyword,
  onClickSearch,
  setSelectedFreeWords,
  setSelectedTypeOfPurchases,
  setSelectedBudgets,
  setSelectedIntroductionTimings,
  setSelectedSpecialties,
  selectedSearchCondition,
  setSelectedSearchCondition,
  setSearchCondition,
  setIsOpenFilterSettingModal,
  setIsOpenFilterDeleteModal,
}) => {
  const onChangeItems = (e: any) => {
    const data = searchContributionSearchConditionsData?.find((item) => {
      return item.id === Number(e.target.value)
    })
    setSelectedSearchCondition(data)
    if (data) {
      // if (data.params.freeWord)
      //   setSelectedFreeWords(data.params.freeWord.split('|'))
      // else setSelectedFreeWords([])

      // if (data.params.typeOfPurchase)
      //   setSelectedTypeOfPurchases(data.params.typeOfPurchase.split('|'))
      // else setSelectedTypeOfPurchases([])

      // if (data.params.specialties)
      //   setSelectedSpecialties(
      //     data.params.specialties
      //       .split('|')
      //       .map((item: string) => Number(item)),
      //   )
      // else setSelectedSpecialties([])

      // if (data.params.budget) setSelectedBudgets(data.params.budget.split('|'))
      // else setSelectedBudgets([])

      // if (data.params.introductionTiming)
      //   setSelectedIntroductionTimings(
      //     data.params.introductionTiming.split('|'),
      //   )
      // else setSelectedIntroductionTimings([])
      setSelectedFreeWords([])
      setSelectedTypeOfPurchases([])
      setSelectedSpecialties([])
      setSelectedBudgets([])
      setSelectedIntroductionTimings([])
      let query: ContributionsQueryParam = {}
      if (data.params?.freeWord) query.free_word = data.params.freeWord
      if (data.params?.typeOfPurchase)
        query.type_of_purchase = data.params.typeOfPurchase
      if (data.params?.specialties) query.specialties = data.params.specialties
      if (data.params?.budget) query.budget = data.params.budget
      if (data.params?.introductionTiming)
        query.introduction_timing = data.params.introductionTiming
      onClickSearch(query)
    } else {
      setSelectedFreeWords([])
      setSelectedTypeOfPurchases([])
      setSelectedSpecialties([])
      setSelectedBudgets([])
      setSelectedIntroductionTimings([])
      onClickSearch()
    }
  }
  return (
    <SearchFilterContent>
      <SearchFilterHeader>
        <SearchFilterTitle>作成済みフィルタ</SearchFilterTitle>
      </SearchFilterHeader>
      <FilterSettingContent>
        <FilterSettingItemDiv key={`全て`}>
          <label>
            <input
              value={-3}
              name="filter_setting"
              type="radio"
              onChange={onChangeForAll}
              checked={selectedSearchCondition?.id === -3}
            />
            <FilterSettingItemInput>全て</FilterSettingItemInput>
          </label>
        </FilterSettingItemDiv>
        {hasKeywords && hasPaid ? (
          <FilterSettingItemDiv key={`キーワード一致`}>
            <label>
              <input
                value={-2}
                name="filter_setting"
                type="radio"
                onChange={onChangeFoKeyword}
                checked={selectedSearchCondition?.id === -2}
              />
              <FilterSettingItemInput>キーワード一致</FilterSettingItemInput>
            </label>
          </FilterSettingItemDiv>
        ) : (
          <></>
        )}
        {hasPaid &&
          searchContributionSearchConditionsData?.map(
            (item: ContributionSearchConditionsData) => {
              const checked = item.id === selectedSearchCondition?.id
              return (
                <FilterSettingItemDiv key={`${item.id}`}>
                  <label>
                    <input
                      value={String(item.id)}
                      name="filter_setting"
                      type="radio"
                      onChange={(e) => onChangeItems(e)}
                      checked={checked}
                    />
                    <FilterSettingItemInput>
                      {item.title}
                    </FilterSettingItemInput>
                  </label>
                  <AsideArea>
                    <PopUpMenu
                      actions={[
                        {
                          label: 'フィルタ名を変更する',
                          onClick: () => {
                            setSearchCondition(item)
                            setIsOpenFilterSettingModal(true)
                          },
                        },
                        {
                          label: '削除する',
                          onClick: () => {
                            setSearchCondition(item)
                            setIsOpenFilterDeleteModal(true)
                          },
                        },
                      ]}
                    />
                  </AsideArea>
                </FilterSettingItemDiv>
              )
            },
          )}
      </FilterSettingContent>
    </SearchFilterContent>
  )
}

const SearchFilterContent = styled.div`
  background: white;
  border-radius: 5px;
  padding: 24px;
  box-shadow: ${defaultShadow};
`
const SearchFilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 8px 18px 8px;
  font-size: 16px;
  font-weight: 700;
`

const SearchFilterTitle = styled.div`
  color: ${_profilegreen};
`

const FilterSettingContent = styled.div`
  display: flex;
  flex-direction: column;
`

const FilterSettingItemDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 6px 8px;
  font-size: 14px;
  label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    input[type='radio'] {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      -o-appearance: none;
      appearance: none;
      position: relative;
      right: 0;
      bottom: 0;
      left: 0;
      transition: all 0.15s ease-out 0s;
      color: #fff;
      cursor: pointer;
      display: inline-block;
      outline: none;
      border-radius: 10%;
    }
    /* Radio */
    input[type='radio'] {
      border-radius: 50%;
      border: 2px solid #bebebe;
    }
    input[type='radio']:checked:before {
      transform: scale(1);
    }
    input[type='radio']:before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin: 3px;
      transform: scale(0);
      transition: all ease-out 250ms;
    }
    input[type='radio']:checked {
      border: 2px solid ${_profilegreen};
    }
    input[type='radio']:checked:before {
      background: ${_profilegreen};
    }
  }
`
const FilterSettingItemInput = styled.span`
  margin: 0px 12px;
`

const AsideArea = styled.aside`
  display: inline-block;
`
